module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"it":{"pageTitle":"Log Viewer","systemSettings":"System Settings"}}')
  delete Component.options._Ctor
}
